import { render, staticRenderFns } from "./SPSubscriptionSettings.vue?vue&type=template&id=679c5504&scoped=true&"
import script from "./SPSubscriptionSettings.vue?vue&type=script&lang=ts&"
export * from "./SPSubscriptionSettings.vue?vue&type=script&lang=ts&"
import style0 from "./SPSubscriptionSettings.vue?vue&type=style&index=0&id=679c5504&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679c5504",
  null
  
)

export default component.exports